<template>
    <v-list-group v-if="type === 'side'" :value="false" active-class="side-active" class="side-txt">
        <template v-slot:activator>
            <v-list-item-icon>
                <v-icon class="side-txt">mdi-bell</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
                NOTIFICACIONES
            </v-list-item-title>
        </template>
        <v-list>
            <v-subheader class="text-menu-side">Notificaciones</v-subheader>
            <template v-for="(notification, index) in notifications">
                <v-list-item
                    :class="{ highlight: !notification.readed }"
                    :key="index"
                    ripple
                    @click="read(index)"
                >
                    <v-list-item-avatar v-if="notification.image">
                        <img :src="notification.image" />
                    </v-list-item-avatar>
                    <v-list-item-icon v-if="notification.icon">
                        <v-icon>{{ notification.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title
                            v-if="notification.html"
                            v-html="notification.html"
                        ></v-list-item-title>
                        <v-list-item-subtitle
                            v-html="parseTimestamp(notification.ts)"
                        ></v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-divider v-if="index + 1 < notifications.length" :key="notification.ts" />
            </template>
        </v-list>
    </v-list-group>
    <v-menu v-else :close-on-content-click="false" open-on-hover bottom offset-y>
        <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon>
                <v-badge :content="unreaded" :value="unreaded" color="info" overlap>
                    <v-icon>mdi-bell</v-icon>
                </v-badge>
            </v-btn>
        </template>
        <v-list>
            <v-subheader>Notificaciones</v-subheader>
            <template v-for="(notification, index) in notifications">
                <v-list-item
                    :class="{ highlight: !notification.readed }"
                    :key="index"
                    ripple
                    @click="read(index)"
                >
                    <v-list-item-avatar v-if="notification.image">
                        <img :src="notification.image" />
                    </v-list-item-avatar>
                    <v-list-item-icon v-if="notification.icon">
                        <v-icon>{{ notification.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title
                            v-if="notification.html"
                            v-html="notification.html"
                        ></v-list-item-title>
                        <v-list-item-subtitle
                            v-html="parseTimestamp(notification.ts)"
                        ></v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-divider v-if="index + 1 < notifications.length" :key="notification.ts" />
            </template>
        </v-list>
    </v-menu>
</template>

<script>
import { mapState } from "vuex";
import { userComputed } from "@/store/helpers.js";
import awsIot from "aws-iot-device-sdk";

export default {
    props: ["type"],
    data() {
        return {
            unreaded: 0,
            credentials: {},
            notifications: [],
            iconTypes: {
                notice: "mdi-newspaper-variant-outline",
                message: "mdi-message"
            },
            timerId: null,
            readed: []
        };
    },
    created() {
        this.$store.dispatch("notifications/get").then(notifications => {
            this.notifications = [];
            notifications.forEach(notification => {
                this.notifications.push(this.format(notification));
                this.unreaded += notification.readed ? 0 : 1;
            });
        });
        this.negociateQueue();
    },
    computed: {
        ...userComputed
    },
    methods: {
        negociateQueue() {
            this.$store
                .dispatch("notifications/keys")
                .then(credentials => {
                    this.client = awsIot.device({
                        region: credentials.region,
                        protocol: "wss",
                        accessKeyId: credentials.accessKey,
                        secretKey: credentials.secretKey,
                        sessionToken: credentials.sessionToken,
                        port: 443,
                        host: credentials.iotEndpoint
                    });

                    this.client.on("connect", this.onConnect.bind(this));
                    this.client.on("message", this.onMessage.bind(this));
                    this.client.on("error", this.onError.bind(this));
                })
                .catch(err => {
                    console.error(err);
                });
        },
        onConnect() {
            this.getUser && this.client.subscribe("ikigai-" + this.getUser.id);
            this.getUser && this.client.subscribe("ikigai-broadcast");
        },
        onMessage(topic, msg) {
            try {
                let notification = JSON.parse(msg);
                this.inject(this.format(notification));
            } catch (err) {
                console.error(err);
            }
        },
        onError(err) {
            console.error(err);
            //sthis.negociateQueue();
        },
        inject(notification) {
            let position = -1;
            for (let index in this.notifications) {
                if (this.notifications[index].id == notification.id) {
                    position = index;
                }
            }
            let unread = 0;
            if (position >= 0) {
                unread = !this.notifications[position].readed;
                this.notifications.splice(position, 1);
            }
            this.notifications.unshift(notification);
            if (this.notifications.length > process.env.VUE_APP_NOTIFICATION_LENGTH)
                delete this.notifications[process.env.VUE_APP_NOTIFICATION_LENGTH];

            this.unreaded += (notification.readed ? 0 : 1) - unread;
        },
        format(notification) {
            return {
                id: notification.id,
                ts: notification.ts,
                readed: notification.readed,
                icon: this.iconTypes[notification.type],
                html: notification.msg
            };
        },
        parseTimestamp(ts) {
            const now = new Date().getTime() / 1000;
            const diff = now - ts;
            const day = 60 * 60 * 24;
            const week = day * 7;
            const month = week * 30;

            let timeAgo = "",
                unit = 0;
            if (diff > month) {
                unit = parseInt(diff / month);
                timeAgo = "Hace " + unit + " Mes" + (unit >= 2 ? "es" : "");
            } else if (diff > week) {
                unit = parseInt(diff / week);
                timeAgo = "Hace " + unit + " Semana" + (unit >= 2 ? "s" : "");
            } else if (diff > day) {
                unit = parseInt(diff / day);
                timeAgo = "Hace " + unit + " Día" + (unit >= 2 ? "s" : "");
            } else if (diff > 3600) {
                unit = parseInt(diff / 3600);
                timeAgo = "Hace " + unit + " Hora" + (unit >= 2 ? "s" : "");
            } else {
                unit = parseInt(diff / 60);
                timeAgo = "Hace " + unit + " Minuto" + (unit >= 2 ? "s" : "");
            }
            return timeAgo;
        },
        read(index) {
            if (this.notifications[index] && !this.notifications[index].readed) {
                this.notifications[index].readed = true;
                this.readed.push(this.notifications[index].id);
                this.unreaded--;

                if (this.timerId) clearTimeout(this.timerId);
                this.timerId = setTimeout(() => {
                    this.$store
                        .dispatch("notifications/update", this.readed)
                        .then(() => {
                            this.readed = [];
                        })
                        .catch(() => {
                            this.readed = [];
                        });
                }, process.env.VUE_APP_NOTIFICATION_UPDATE_TIMEOUT);
            }
        }
    }
};
</script>

<style scoped>
.highlight {
    border-left: 5px solid #3badff !important;
}
.side-txt .v-icon {
    color: #3c52a0;
    font-family: "CircularMedium" !important;
}
.side-txt .v-list-item__title {
    color: #3c52a0;
    font-family: "CircularMedium" !important;
}
.side-active {
    color: #3badff !important;
    font-family: "CircularMedium" !important;
}
.side-active .v-list-item__title {
    color: #3badff;
    font-family: "CircularMedium" !important;
}
</style>
